import { render, staticRenderFns } from "./Apoio.vue?vue&type=template&id=018129da&scoped=true&lang=pug&"
import script from "./Apoio.vue?vue&type=script&lang=js&"
export * from "./Apoio.vue?vue&type=script&lang=js&"
import style0 from "./Apoio.styl?vue&type=style&index=0&id=018129da&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018129da",
  null
  
)

export default component.exports